<script setup>
import { Link } from '@inertiajs/vue3'
defineProps({
  title:  { type: String,  required: true },
  url:    { type: String,  required: true },
  active: { type: Boolean, default: false },
})
</script>
<template>
  <Link
    :href="url"
    :data-active="active ? 'true' : undefined"
    class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-150 group"
    :class="active
      ? 'bg-white text-primary font-semibold shadow-sm'
      : 'text-white/80 hover:text-white hover:bg-white/10'"
  >
    <span
      class="shrink-0 transition-colors"
      :class="active
        ? 'text-primary'
        : 'text-white/70 group-hover:text-white'"
    >
      <slot />
    </span>
    <span>{{ title }}</span>
  </Link>
</template>